"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NavigateToStep = void 0;
var react_use_1 = require("react-use");
var core_1 = require("../core");
/**
 * Simple helper component that will navigate to the nominated step when it mounts. This should be used in
 * place of the `Navigate` or `Redirect` components from react-router when navigation needs to go to a step.
 */
var NavigateToStep = function (_a) {
    var step = _a.step;
    var goToStep = (0, core_1.useWizardStepNavigate)();
    (0, react_use_1.useMount)(function () { return goToStep(step); });
    return null;
};
exports.NavigateToStep = NavigateToStep;
//# sourceMappingURL=NavigateToStep.js.map